import React, { Component } from "react"

/* REST API */
import { edit_role, permissions, role_by_id } from "../../api/Permissions"

/* Sweet alert */
import Swal from "sweetalert2"

/* Icons */
import { LoadingOutlined } from '@ant-design/icons'

/* Helpers */
import { withRouter } from '../../helpers'

import SelectRoleMenu from "./widgets/SelectRoleMenu"


/*
    Page Edit Role
*/
class EditRole extends Component {

    constructor(props) {
        super(props)

        const { params } = this.props

        this.state = {
            id: params.id,
            role: '',
            loading: true,

            permissions: null,
            selected_permissions: [],
        }
    }

    componentDidMount = () => {
        this.load()
        this.loadPermissions()
    }

    load = () => {
        const { id } = this.state
        role_by_id({ roleID: id }).then(response => {
            if (response.status === 200) {
                const role = response.data.role
                const selected = (role.permissions || []).map(p => ({ id: p.id, name: p.name }))
                this.setState({ role: role.name, selected_permissions: selected, loading: false })
            }
        })
    }

    loadPermissions = () => {
        permissions({}).then(response => {
            if (response.status === 200) {
                this.setState({ permissions: response.data.permissions })
            }
        })
    }

    save = () => {
        const { id, role, selected_permissions } = this.state
        const { navigate } = this.props

        if (role === '') {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите название роли', showConfirmButton: false, timer: 1500 })
            return
        }

        if (selected_permissions.length === 0) {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Выберите разрешения', showConfirmButton: false, timer: 1500 })
            return
        }

        const permissionIDs = selected_permissions.map(p => p.id)

        edit_role({ roleID: id, name: role, permissionIDs }).then(response => {
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Успешно сохранено',
                    showConfirmButton: false,
                    timer: 1500,
                    didClose: () => navigate('/roles')
                })
            } else {
                Swal.fire({ icon: 'error', title: 'Что-то пошло не так! Попробуйте позднее', showConfirmButton: false, timer: 1500 })
            }
        }).catch(() => {
            Swal.fire({ icon: 'error', title: 'Что-то пошло не так! Попробуйте позднее', showConfirmButton: false, timer: 1500 })
        })
    }

    _top = () => (
        <div className="content-top">
            <div className="content-name">
                <img src="/pictures/category.png" alt="Role" />
                <p>Редактировать роль</p>
            </div>
        </div>
    )

    render = () => {

        const { permissions, selected_permissions, role, loading } = this.state

        if (loading) {
            return (
                <div className="content">
                    {this._top()}
                    <div className="content-element"><LoadingOutlined /></div>
                </div>
            )
        }

        return (
            <div className="content">
                {this._top()}

                <div className="content-box">
                    <div className="content-form-box">

                        <div className="content-form-half">
                            <p>Роль</p>
                            <input type="text" value={role} onChange={event => this.setState({ role: event.target.value })} placeholder="Название" />
                        </div>

                        <div className="content-form-half">
                            <p>Разрешения</p>
                            <SelectRoleMenu
                                list={permissions}
                                items={selected_permissions}
                                update={(data) => this.setState({ selected_permissions: data })}
                            />
                        </div>

                    </div>

                    <div className="content-form-bottom">
                        <div onClick={() => this.save()} className="content-form-button">Сохранить</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(EditRole)
